import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import { memo, useEffect } from 'react';
import { Trans } from '@bonanza-social/i18n';
import { AsyncStorage } from '@bonanza-social/toolkit/storage';
import { SOF_BOTTOM_SHEET_LAST_SHOW_TIME_STORAGE_KEY } from './SOF.constants';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectSourceOfFundsForm } from '../../state';

function SOFBottomSheet({ close }: BottomSheetExtendedProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const { id } = useSelector(selectSourceOfFundsForm) || {};

  useEffect(() => {
    if (!id) {
      return;
    }

    AsyncStorage.setItem(
      SOF_BOTTOM_SHEET_LAST_SHOW_TIME_STORAGE_KEY,
      JSON.stringify({
        formId: id,
        time: Date.now(),
      }),
    );
  }, [id]);

  const handleAccountNavigation = () => {
    navigation.navigate('Account');
  };

  const handleFillFormNavigation = () => {
    navigation.navigate('SOFAttestation');
  };

  return (
    <Box>
      <Image
        name="account.Documents"
        resizeMode="contain"
        width={64}
        height={80}
        alignSelf="center"
      />
      <Text
        variant="h4"
        color="darkSurfacePrimary"
        locNS="account"
        locKey="SOFWeNeedYourHelp"
        textAlign="center"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="account"
        locKey="SOFInformationIsRequired"
        textAlign="center"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        textAlign="center"
        marginVertical="space-400"
      >
        <Trans
          i18nKey="SOFYouCanAccessTheForm"
          ns="account"
          components={{
            span: (
              <Text
                variant="link-medium"
                color="level_2"
                onPress={handleAccountNavigation}
              />
            ),
          }}
        />
      </Text>
      <Box gap="space-400">
        <Button
          variant="primary"
          onPress={handleFillFormNavigation}
          locNS="account"
          locKey="SOFFillForm"
        />
        <Button
          variant="secondary"
          onPress={close}
          locNS="account"
          locKey="SOFRemindMeLater"
        />
      </Box>
    </Box>
  );
}

export default memo(SOFBottomSheet);
